import React from 'react';
import classnames from 'classnames';

const block = 'airtame-info-message-title';

export type InfoMessageTitleProps = React.HTMLAttributes<HTMLHeadingElement>;

export const InfoMessageTitle = ({
  className,
  ...props
}: InfoMessageTitleProps): React.ReactElement => {
  const classNames = classnames(className, block);

  return <div className={classNames} {...props} />;
};
